import React, { useContext } from 'react'
import TicketStatuses from './TicketStatuses'
import TicketByBuilding from './TicketByBuilding';
import TicketsByGrade from './TicketsByGrade';
import PartUsed from './PartUsed';
import KPI from './KPI';
import { ReportDataContext } from '../index';
import useConfig from '../../../Hooks/useConfig';

export default function DeviceReportsIndex({ setAlerts }) {
    const { show_grade_field, show_department_graph } = useConfig();
    const { AllReportData } = useContext(ReportDataContext);
    return (
        <>
            <div className='row'>
                <div className='col-md-12  py-2'>
                    <TicketStatuses data={AllReportData?.ticket_status_data?.data} loder={AllReportData?.ticket_status_data?.loader} setAlerts={setAlerts} />
                </div>
                <div className='col-md-6 py-2'>
                    <TicketByBuilding data={AllReportData?.ticket_by_building_data?.data?.data} CsvData={AllReportData?.ticket_by_building_data?.data?.ticket_data} loder={AllReportData?.ticket_by_building_data?.loader} setAlerts={setAlerts} />
                </div>
                {show_grade_field &&
                    <div className='col-md-6 py-2'>
                        <TicketsByGrade data={AllReportData?.ticket_by_grade_data?.data?.data} CsvData={AllReportData?.ticket_by_grade_data?.data?.ticket_data} loder={AllReportData?.ticket_by_grade_data?.loader} setAlerts={setAlerts} />
                    </div>
                }
                {show_department_graph &&
                    <div className='col-md-6 py-2'>
                        <TicketsByGrade data={AllReportData?.ticket_by_grade_data?.data?.data} CsvData={AllReportData?.ticket_by_grade_data?.data?.ticket_data} loder={AllReportData?.ticket_by_grade_data?.loader} setAlerts={setAlerts} />
                    </div>
                }
                <div className='col-md-6 py-2'>
                    <PartUsed data={AllReportData?.part_used_data?.data} loder={AllReportData?.part_used_data?.loader} setAlerts={setAlerts} />
                </div>
                <div className='col-md-6 py-2'>
                    <KPI data={AllReportData?.kpi_data?.data?.data} loder={AllReportData?.kpi_data?.loader} CsvData={AllReportData?.kpi_data?.data?.ticket_data} setAlerts={setAlerts} />
                </div>
            </div>
        </>
    )
}
